import ClubPeekCard from "./ClubPeekCard";

const SKELETON_COUNT = 3;

// One club carousel. A row that is empty or failed hides itself, title included
// — a "type 4" heading over a "nothing found" message is noise on a feed.
function ClubCarouselRow({ title, row, priceForClub, showPrice = true, defaultClubImg, imgFallbackSrc }) {
  const status = row?.status ?? "loading";
  const items = row?.items ?? [];

  if (status === "error") return null;
  if (status === "ready" && items.length === 0) return null;

  return (
    <section className="hm-v2-row">
      {status === "loading" ? (
        <div className="hm-v2-row-title-skeleton" aria-hidden="true" />
      ) : (
        <h2 className="hm-v2-row-title">{title}</h2>
      )}
      <div className="hm-v2-row-track">
        {status === "loading"
          ? Array.from({ length: SKELETON_COUNT }, (_, index) => (
              <div key={index} className="hm-v2-card hm-v2-card--skeleton" aria-hidden="true">
                <div className="hm-v2-card-img-skeleton" />
                <div className="hm-v2-card-line-skeleton" />
                <div className="hm-v2-card-line-skeleton hm-v2-card-line-skeleton--short" />
              </div>
            ))
          : items.map((club) => (
              <ClubPeekCard
                key={club.ClubID}
                club={club}
                price={showPrice ? priceForClub(club.ClubID) : null}
                defaultClubImg={defaultClubImg}
                imgFallbackSrc={imgFallbackSrc}
              />
            ))}
      </div>
    </section>
  );
}

export default ClubCarouselRow;
